import { render, staticRenderFns } from "./WalletActivityItem.vue?vue&type=template&id=90334e10&"
import script from "./WalletActivityItem.vue?vue&type=script&lang=js&"
export * from "./WalletActivityItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports